import { TRANSACTION_ROUTE_NAME } from '@/libs/route-name';

export const transactionRoute = () => {
    return {
        name: TRANSACTION_ROUTE_NAME.TRANSACTION,
        path: 'transaction',
        component: () => import('@/pages/transaction/index.vue'),
    };
};
